// extracted by mini-css-extract-plugin
module.exports = {"side_bar_wrapper":"sideBar_side_bar_wrapper__bxObA","side_bar":"sideBar_side_bar__yHiUO","hide":"sideBar_hide__XBiAp"};